export default __webpack_public_path__ + "static/media/mail_purple_24dp.ebd66bc6.svg";